import React from 'react'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import measurementTypes from '../../_constants/measurementTypes'

export const MySelect = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

class MeasurementTypeSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: measurementTypes,
      SelectedBank: '',
      province: this.props.province,
      loading: false,
      defaultValue: this.props.defaultValue,
      disabled: this.props.disabled
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   if ('value' in nextProps && nextProps.value !== this.props.value) {
  //     this.setMomentValue(nextProps.value);
  //   }
  // }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue })
    }
  }

  // shouldComponentUpdate(nextProps){
  //   return true;
  // }

  handleBankIdChange = e => {
    // // console.log(e);
    let SelectedBank = e.id
    this.setState({ SelectedBank: SelectedBank })
    // // console.log(e);
  }

  handleChange = e => {
    // // console.log(e.id);
    this.props.onChange(e ? e.value : null)
  }

  render() {
    const customStyles = {
      // option: (provided, state) => ({
      //   ...provided,
      //
      // }),
      control: provided => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#f6f6f6',
        borderRadius: 20,
        // height: 40,
        boxShadow: 'none',
        border: 'none',
        paddingRight: '12'
      }),
      option: provided => ({
        // none of react-select's styles are passed to <Control />
        ...provided
        // height: 55,
      }),
      indicatorSeparator: () => ({
        display: 'none'
      })
    }
    // const Option = props => {
    //   const {data} = props;
    //   return (
    //     <components.Option {...props}>

    //       <img style={{height: 40, width: 40, display: 'inline', marginLeft: 5}} alt='' src={config.uploadsUrl+data.logoName} />

    //     <span>
    //       {data.label}
    //     </span>
    //     </components.Option>
    //   );
    // };

    const { data, loading, disabled, defaultValue } = this.state
    const { clearable } = this.props

    return (
      <div>
        {!loading && (
          <MySelect
            isDisabled={disabled}
            placeholder=""
            styles={customStyles}
            options={data}
            value={defaultValue}
            onChange={this.handleChange}
            Searchable
            rtl
            isClearable={clearable}
          />
        )}
      </div>
    )
  }
}
export default MeasurementTypeSelect
